(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ar-puzzle-single-menu"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sd-temple-puzzle-details')) {
  customElements.define('sd-temple-puzzle-details', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.events = new AbortController();
      const controller = this.events;
      const initialize = () => {
        if (this.isConnected && this.events === controller) this.initialize();
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, { once: true, signal: controller.signal });
      } else {
        queueMicrotask(initialize);
      }
    }
    initialize() {
      this.rail = this.querySelector('[role="tablist"]');
      this.wrap = this.querySelector('.sd-puzzle__nav-wrap');
      this.more = this.querySelector('.sd-puzzle__more');
      if (!this.rail || !this.wrap) return;
      this.tabs = Array.from(this.rail.querySelectorAll('[role="tab"]'));
      this.boundViewers = new WeakSet();
      const options = { signal: this.events.signal };
      this.tabs.forEach(tab => tab.addEventListener('click', () => this.activate(tab), options));
      this.rail.addEventListener('keydown', event => {
        const current = this.tabs.indexOf(event.target);
        if (current < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const rtl = getComputedStyle(this).direction === 'rtl';
        let next = current;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
        if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
        event.preventDefault();
        next = (next + this.tabs.length) % this.tabs.length;
        this.tabs[next].focus({ preventScroll: true });
        this.activate(this.tabs[next]);
      }, options);
      this.rail.addEventListener('scroll', () => this.updateNavigation(), { ...options, passive: true });
      this.more?.addEventListener('click', () => {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        const atEnd = Math.abs(this.rail.scrollLeft) >= max - 4;
        const rtl = getComputedStyle(this).direction === 'rtl';
        this.rail.scrollTo({ left: atEnd ? 0 : this.rail.scrollLeft + this.rail.clientWidth * .75 * (rtl ? -1 : 1), behavior: this.motion() });
      }, options);
      this.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        const zoom = event.target.closest('[data-sd-puzzle-zoom]');
        if (zoom && zoom.closest('sd-temple-puzzle-details') === this) {
          this.openViewer(zoom);
          return;
        }
        const close = event.target.closest('.sd-puzzle__close');
        if (close && close.closest('sd-temple-puzzle-details') === this) {
          this.viewer?.close();
          return;
        }
        if (event.target === this.viewer) {
          const bounds = this.viewer.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.viewer.close();
        }
      }, options);
      this.ensureViewer();
      this.observer = new ResizeObserver(() => this.updateNavigation());
      this.observer.observe(this.wrap);
      this.updateNavigation();
      if (document.fonts) document.fonts.ready.then(() => {
        if (this.isConnected && !options.signal.aborted) this.updateNavigation();
      });
    }
    ensureViewer() {
      let viewer = this.querySelector('dialog.sd-puzzle__viewer');
      if (!viewer) {
        viewer = document.createElement('dialog');
        viewer.className = 'sd-puzzle__viewer';
        viewer.id = this.querySelector('[data-sd-puzzle-zoom]')?.getAttribute('aria-controls') || `${this.id}-viewer`;
        viewer.setAttribute('aria-label', 'Product image viewer');
        this.append(viewer);
      }
      if (!viewer.querySelector('.sd-puzzle__close')) {
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'sd-puzzle__close';
        close.setAttribute('aria-label', 'Close image');
        close.textContent = 'Close ×';
        viewer.append(close);
      }
      if (!viewer.querySelector('.sd-puzzle__viewer-content')) {
        const content = document.createElement('div');
        content.className = 'sd-puzzle__viewer-content';
        viewer.append(content);
      }
      if (!this.boundViewers.has(viewer)) {
        viewer.addEventListener('close', () => {
          viewer.querySelector('.sd-puzzle__viewer-content')?.replaceChildren();
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
          this.opener = null;
        }, { signal: this.events.signal });
        this.boundViewers.add(viewer);
      }
      this.viewer = viewer;
      return viewer;
    }
    openViewer(button) {
      const source = button.querySelector('img');
      if (!source) return;
      const viewer = this.ensureViewer();
      const image = document.createElement('img');
      image.src = button.dataset.fullSrc || source.src || source.currentSrc;
      image.alt = source.alt;
      image.loading = 'eager';
      image.decoding = 'async';
      viewer.querySelector('.sd-puzzle__viewer-content').replaceChildren(image);
      this.opener = button;
      if (!viewer.open) viewer.showModal();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      if (this.viewer?.open) this.viewer.close();
      this.opener = null;
    }
    motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
    updateNavigation() {
      if (!this.rail || !this.wrap || !this.more) return;
      const overflowing = this.rail.scrollWidth > this.wrap.clientWidth + 2;
      this.wrap.classList.toggle('is-overflowing', overflowing);
      this.more.hidden = !overflowing;
      const atEnd = Math.abs(this.rail.scrollLeft) >= this.rail.scrollWidth - this.rail.clientWidth - 4;
      this.more.classList.toggle('is-at-end', atEnd);
      this.more.setAttribute('aria-label', atEnd ? 'Back to first product detail tab' : 'Show more product detail tabs');
    }
    activate(tab) {
      this.tabs.forEach(item => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        const panel = this.querySelector(`[id="${item.getAttribute('aria-controls')}"]`);
        if (panel) panel.hidden = !active;
      });
      const bounds = tab.getBoundingClientRect();
      const railBounds = this.rail.getBoundingClientRect();
      const offset = bounds.left < railBounds.left + 4 ? bounds.left - railBounds.left - 4 : bounds.right > railBounds.right - 4 ? bounds.right - railBounds.right + 4 : 0;
      if (offset) this.rail.scrollBy({ left: offset, behavior: this.motion() });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pill-bar-bas"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('sd-product-details')) {
    customElements.define('sd-product-details', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[role="tablist"]');
        this.tabs = Array.from(this.rail.querySelectorAll('[role="tab"]'));
        this.more = this.querySelector('.sd-details__more');
        this.wrap = this.querySelector('.sd-details__nav-wrap');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.tabs.forEach(tab => tab.addEventListener('click', () => this.activate(tab), options));
        this.rail.addEventListener('keydown', event => {
          const current = this.tabs.indexOf(event.target);
          if (current < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          let next = current;
          const rtl = getComputedStyle(this).direction === 'rtl';
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
          if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
          event.preventDefault();
          next = (next + this.tabs.length) % this.tabs.length;
          this.tabs[next].focus({ preventScroll: true });
          this.activate(this.tabs[next]);
        }, options);
        this.rail.addEventListener('scroll', () => this.updateNavigation(), { ...options, passive: true });
        this.more.addEventListener('click', () => {
          const max = this.rail.scrollWidth - this.rail.clientWidth;
          const atEnd = Math.abs(this.rail.scrollLeft) >= max - 4;
          const rtl = getComputedStyle(this).direction === 'rtl';
          this.rail.scrollTo({ left: atEnd ? 0 : this.rail.scrollLeft + this.rail.clientWidth * .75 * (rtl ? -1 : 1), behavior: this.motion() });
        }, options);
        this.viewer = this.querySelector('.sd-details__viewer');
        this.querySelectorAll('[data-sd-zoom]').forEach(button => button.addEventListener('click', () => {
          const source = button.querySelector('img');
          const image = document.createElement('img');
          image.src = source.currentSrc || source.src;
          image.alt = source.alt;
          this.viewer.classList.toggle('is-rotated', Boolean(button.querySelector('.is-rotated')));
          this.viewer.querySelector('.sd-details__viewer-content').replaceChildren(image);
          this.viewer.showModal();
        }, options));
        this.viewer.querySelector('.sd-details__close').addEventListener('click', () => this.viewer.close(), options);
        this.viewer.addEventListener('click', event => {
          if (event.target === this.viewer) this.viewer.close();
        }, options);
        this.observer = new ResizeObserver(() => this.updateNavigation());
        this.observer.observe(this.wrap);
        this.updateNavigation();
        if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.updateNavigation(); });
      }
      disconnectedCallback() {
        this.events?.abort();
        this.observer?.disconnect();
      }
      motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      updateNavigation() {
        const overflowing = this.rail.scrollWidth > this.wrap.clientWidth + 2;
        this.wrap.classList.toggle('is-overflowing', overflowing);
        this.more.hidden = !overflowing;
        const atEnd = Math.abs(this.rail.scrollLeft) >= this.rail.scrollWidth - this.rail.clientWidth - 4;
        this.more.classList.toggle('is-at-end', atEnd);
        this.more.setAttribute('aria-label', atEnd ? 'Back to first product detail tab' : 'Show more product detail tabs');
      }
      activate(tab) {
        this.tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          const panel = this.querySelector('[id="' + item.getAttribute('aria-controls') + '"]');
          if (panel) panel.hidden = !active;
        });
        const bounds = tab.getBoundingClientRect();
        const railBounds = this.rail.getBoundingClientRect();
        const offset = bounds.left < railBounds.left + 4 ? bounds.left - railBounds.left - 4 : bounds.right > railBounds.right - 4 ? bounds.right - railBounds.right + 4 : 0;
        if (offset) this.rail.scrollBy({ left: offset, behavior: this.motion() });
      }
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ramayanaXdd-menu"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sd-combo-details')) {
  customElements.define('sd-combo-details', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      this.events = new AbortController();
      const controller = this.events;
      const initialize = () => {
        if (this.isConnected && this.events === controller) this.initialize();
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, { once: true, signal: controller.signal });
      } else {
        queueMicrotask(initialize);
      }
    }
    initialize() {
      this.rail = this.querySelector('[role="tablist"]');
      this.wrap = this.querySelector('.sd-combo__nav-wrap');
      this.more = this.querySelector('.sd-combo__more');
      if (!this.rail || !this.wrap) return;
      this.tabs = Array.from(this.rail.querySelectorAll('[role="tab"]'));
      this.boundViewers = new WeakSet();
      const options = { signal: this.events.signal };
      this.activate(this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || this.tabs[0]);
      this.tabs.forEach(tab => tab.addEventListener('click', () => this.activate(tab), options));
      this.rail.addEventListener('keydown', event => {
        const current = this.tabs.indexOf(event.target);
        if (current < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const rtl = getComputedStyle(this).direction === 'rtl';
        let next = current;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.tabs.length - 1;
        if (event.key === 'ArrowRight') next += rtl ? -1 : 1;
        if (event.key === 'ArrowLeft') next += rtl ? 1 : -1;
        event.preventDefault();
        next = (next + this.tabs.length) % this.tabs.length;
        this.tabs[next].focus({ preventScroll: true });
        this.activate(this.tabs[next]);
      }, options);
      this.rail.addEventListener('scroll', () => this.updateNavigation(), { ...options, passive: true });
      this.more?.addEventListener('click', () => {
        const max = this.rail.scrollWidth - this.rail.clientWidth;
        const atEnd = Math.abs(this.rail.scrollLeft) >= max - 4;
        const rtl = getComputedStyle(this).direction === 'rtl';
        this.rail.scrollTo({ left: atEnd ? 0 : this.rail.scrollLeft + this.rail.clientWidth * .75 * (rtl ? -1 : 1), behavior: this.motion() });
      }, options);
      this.addEventListener('click', event => {
        if (!(event.target instanceof Element)) return;
        const zoom = event.target.closest('[data-sd-combo-zoom]');
        if (zoom && zoom.closest('sd-combo-details') === this) {
          this.openViewer(zoom);
          return;
        }
        const close = event.target.closest('.sd-combo__close');
        if (close && close.closest('sd-combo-details') === this) {
          this.viewer?.close();
          return;
        }
        if (event.target === this.viewer) {
          const bounds = this.viewer.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.viewer.close();
        }
      }, options);
      this.ensureViewer();
      this.observer = new ResizeObserver(() => this.updateNavigation());
      this.observer.observe(this.wrap);
      this.updateNavigation();
      if (document.fonts) document.fonts.ready.then(() => {
        if (this.isConnected && !options.signal.aborted) this.updateNavigation();
      });
    }
    ensureViewer() {
      let viewer = this.querySelector('dialog.sd-combo__viewer');
      if (!viewer) {
        viewer = document.createElement('dialog');
        viewer.className = 'sd-combo__viewer';
        viewer.id = this.querySelector('[data-sd-combo-zoom]')?.getAttribute('aria-controls') || `${this.id}-viewer`;
        viewer.setAttribute('aria-label', this.dataset.viewerLabel);
        this.append(viewer);
      }
      if (!viewer.querySelector('.sd-combo__close')) {
        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'sd-combo__close';
        close.setAttribute('aria-label', this.dataset.closeLabel);
        close.textContent = this.dataset.closeLabel;
        viewer.append(close);
      }
      if (!viewer.querySelector('.sd-combo__viewer-content')) {
        const content = document.createElement('div');
        content.className = 'sd-combo__viewer-content';
        viewer.append(content);
      }
      if (!this.boundViewers.has(viewer)) {
        viewer.addEventListener('close', () => {
          viewer.querySelector('.sd-combo__viewer-content')?.replaceChildren();
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
          this.opener = null;
        }, { signal: this.events.signal });
        this.boundViewers.add(viewer);
      }
      this.viewer = viewer;
      return viewer;
    }
    openViewer(button) {
      const source = button.querySelector('img');
      if (!source) return;
      const viewer = this.ensureViewer();
      const image = document.createElement('img');
      image.src = button.dataset.fullSrc || source.currentSrc || source.src;
      image.alt = source.alt;
      image.loading = 'eager';
      image.decoding = 'async';
      viewer.querySelector('.sd-combo__viewer-content').replaceChildren(image);
      this.opener = button;
      if (!viewer.open) viewer.showModal();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
      if (this.viewer?.open) this.viewer.close();
      this.opener = null;
    }
    motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
    updateNavigation() {
      if (!this.rail || !this.wrap || !this.more) return;
      const overflowing = this.rail.scrollWidth > this.wrap.clientWidth + 2;
      this.wrap.classList.toggle('is-overflowing', overflowing);
      this.more.hidden = !overflowing;
      const atEnd = Math.abs(this.rail.scrollLeft) >= this.rail.scrollWidth - this.rail.clientWidth - 4;
      this.more.classList.toggle('is-at-end', atEnd);
      this.more.setAttribute('aria-label', atEnd ? this.dataset.firstLabel : this.dataset.moreLabel);
    }
    activate(tab) {
      this.tabs.forEach(item => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
        const panel = this.querySelector(`[id="${item.getAttribute('aria-controls')}"]`);
        if (panel) panel.hidden = !active;
      });
      const bounds = tab.getBoundingClientRect();
      const railBounds = this.rail.getBoundingClientRect();
      const offset = bounds.left < railBounds.left + 4 ? bounds.left - railBounds.left - 4 : bounds.right > railBounds.right - 4 ? bounds.right - railBounds.right + 4 : 0;
      if (offset) this.rail.scrollBy({ left: offset, behavior: this.motion() });
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
